const getMerchantDetailsData = (merchantDetailsState: any): any[] => {
  const data = merchantDetailsState?.data;
  return Array.isArray(data) ? data : [];
};

/**
 * Merchant details are returned as an array of small configuration objects.
 * Keep that response shape at the reducer boundary and expose named values to
 * consumers, so pages do not depend on positional array indexes.
 */
export const getMerchantDetailsValue = (
  merchantDetailsState: any,
  key: string
): any => {
  const detail = getMerchantDetailsData(merchantDetailsState).find(
    (item) =>
      item &&
      typeof item === 'object' &&
      Object.prototype.hasOwnProperty.call(item, key)
  );

  return detail?.[key];
};

export const selectMerchantDetailsState = (state: any) =>
  state?.MerchantListingReducer?.merchantOdsData;

export const selectMerchantDetailsValue = (state: any, key: string): any =>
  getMerchantDetailsValue(selectMerchantDetailsState(state), key);

export const selectCheckoutVersion = (state: any) =>
  selectMerchantDetailsValue(state, 'checkoutVersion');

export const selectMerchantCreatedAt = (state: any) =>
  selectMerchantDetailsValue(state, 'merchantCreatedAt');

export const selectAccountSource = (state: any) =>
  selectMerchantDetailsValue(state, 'accountSource');

export const isSelfGeneratedMerchantAccount = (
  accountSource: unknown
): boolean =>
  typeof accountSource === 'string' &&
  accountSource.trim().toUpperCase() === 'SELF GENERATED';

export const shouldShowEdgePaymentLinks = (
  isEdgePaymentLinkEnabled: unknown,
  accountSource: unknown
): boolean =>
  Boolean(isEdgePaymentLinkEnabled) &&
  !isSelfGeneratedMerchantAccount(accountSource);

export const selectBrandWalletEnabled = (state: any): boolean =>
  selectMerchantDetailsValue(state, 'isBrandWalletEnabled') ?? false;

export const selectOdsEnabled = (state: any): boolean =>
  selectMerchantDetailsValue(state, 'isODSEnabled') ?? false;

export const selectOdsLimit = (state: any): number =>
  selectMerchantDetailsValue(state, 'merchantODSLimit') ?? 0;
